import { useEffect, useState } from 'react'

export const useLoader = (loading: boolean, delay: number) => {
  const [showLoader, setShowLoader] = useState(loading)

  useEffect(() => {
    if (!loading) {
      setShowLoader(false)
      return
    }

    const timeout = setTimeout(() => {
      setShowLoader(true)
    }, delay)

    return () => clearTimeout(timeout)
  }, [loading])

  return showLoader
}
